function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { KeyGenerator, toSlug } from "@superwall-me/schema";
import * as faker from "faker";
export const applicationWithoutIds = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(_param = {}) {
        var args = _extends({}, _object_destructuring_empty(_param));
        const _ref = yield applicationFactory(_object_spread({}, args)), { id, organizationId, creatorId } = _ref, application = _object_without_properties(_ref, [
            "id",
            "organizationId",
            "creatorId"
        ]);
        return application;
    });
    return function applicationWithoutIds() {
        return _ref.apply(this, arguments);
    };
}();
export const applicationFactory = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function*(args) {
        const name = faker.company.companyName();
        return _object_spread({
            name,
            slug: toSlug(name),
            // FitnessAI RC Key
            revenueCatPublicAPIKey: "ZFZFYcjSDvgFZQvIVZFxSnNgBOAloffe",
            appId: "1234",
            publicApiKey: yield KeyGenerator.publicAPI(),
            appleUrlScheme: "fitnessai",
            featuresEnabled: "triggers,charts,users,notifications,localization,editor_v4",
            localizationProviderId: undefined
        }, args);
    });
    return function applicationFactory(args) {
        return _ref.apply(this, arguments);
    };
}();
